<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9L0qcG/tc-custom/9781497650008.jpg?1706910586858" alt="This image is the cover for the book Can You Feel Anything When I Do This?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Can You Feel Anything When I Do This?
      </h1>
      <p class="bookDescription body article font2">
        <b>A treasury of fiction from “</b><b>one of SF’s all-time masters of the humorous or satirical short story” (<i>Booklist</i>).</b><br/>  <br/> In “The Cruel Equations,” a planetary explorer finds out how lethal it can be when a robot guard has been designed to do too perfect a job.<br/><br/> The fifteen other stories in this collection are “Can You Feel Anything When I Do This?”, “Cordle to Onion to Carrot,” “The Petrified World,” “Game: First Schematic,” “Doctor Zombie and His Little Furry Friends,” “The Same to You Doubled,” “Starting From Scratch,” “The Mnemone,” “Tripout,” “Notes on the Perception of Imaginary Differences,” “Down the Digestive Tract and Into the Cosmos With Mantra, Tantra, and Specklebang,” “Pas de Trois of the Chef and the Waiter,” “Aspects of Langranak,” “Plague Circuit,” and “Tailpipe to Disaster.”<br/><br/> From the very beginning of his career, Robert Sheckley was recognized by fans, reviewers, and fellow authors as a master storyteller and the wittiest satirist working in the science fiction field. Open Road is proud to republish his acclaimed body of work, with nearly thirty volumes of full-length fiction and short story collections. Rediscover, or discover for the first time, a master of science fiction who, according to the <i>New York Times</i>, was “a precursor to Douglas Adams.”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Sheckley
      </h2>
      
      <p class="authorDescription body article">Robert Sheckley was one of the funniest writers in the history of science fiction. He did screwball comedy, broad satire, and farce. He could also be deadly serious, but he was always entertaining and always had something pointed to say about our world using the skewed versions of reality he created in his fiction. Starting in the early 1950s, he was an amazingly prolific short story writer, with a lot of his stories appearing in&#160;<I>Galaxy Magazine</I>. He launched his novel-writing career with&#160;<I>Immortality, Inc</I>., which he followed up with a sequence of excellent books:&#160;<I>The Status Civilization</I>,&#160;<I>Journey Beyond Tomorrow</I>, and&#160;<I>Mindswap</I>. He continued to produce novels and short stories in abundance until his death in 2005.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      E-Reads
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b6f356c